import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SFDivider from "../../divider";
import SFLink from "../../link";
import getStyled from "../../../hooks/getStyled";

const { styled } = getStyled();

export const VersionLinkWRapper = styled("div")(({ theme }) => ({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  "& .MuiDivider-root": {
    borderStyle: "dashed",
    width: "100%",
  },
  "& .MuiTypography-root": {
    textDecoration: "none",
    cursor: "pointer",
    textTransform: "none",
    textAlign: "center",
    color: theme.palette.grey400.main,
    paddingTop: 20,
    paddingBottom: 10,
  },
}));


const VersionLink = ({ releaseNotesRoute, activeVersion }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <VersionLinkWRapper>
      <SFDivider />
      <SFLink
        variant="tableListDescription"
        onClick={() => navigate(releaseNotesRoute.path)}
      >
        {t("navigation.versionPrefix", {
          version: activeVersion,
        })}
      </SFLink>
    </VersionLinkWRapper>
  );
};

export default VersionLink;

